export class BaseElement extends HTMLElement {
  static className = ""

  static define(name: string, klass: typeof BaseElement) {
    // eslint-disable-next-line no-param-reassign
    klass.className = name
    customElements.define(`fc-${name}`, klass)
  }

  addClassName() {
    this.classList.add(this.baseClassName())
  }

  baseClassName() {
    return (this.constructor as typeof BaseElement).className
  }

  modClassName(mod: string) {
    return `${this.baseClassName()}--${mod}`
  }

  elementClassName(name: string) {
    return `${this.baseClassName()}__${name}`
  }

  element(name: string) {
    return this.querySelector(`.${this.elementClassName(name)}`)
  }

  elements(name: string) {
    return Array.from(this.querySelectorAll(`.${this.elementClassName(name)}`))
  }

  emit<T>(name: string, detail?: T) {
    this.dispatchEvent(new CustomEvent(name, { detail, bubbles: true }))
  }
}
